import { ApexOptions } from 'apexcharts';
import { PrmOrganizationCurriculumProgress } from 'types/schema-generated-types';

export const buildPieChartOptions = (value: PrmOrganizationCurriculumProgress): ApexOptions => ({
  legend: {
    show: false
  },
  stroke: {
    lineCap: 'round'
  },
  dataLabels: {
    enabled: false
  },
  plotOptions: {
    pie: {
      donut: {
        size: '80%',
        labels: {
          show: true,
          name: {
            show: false
          },
          total: {
            show: true,
            showAlways: true,
            formatter: (val: any) => {
              return `${(value.averageLessonCompletedCount / value.totalLessonCount) * 100}%`;
            }
          }
        }
      }
    }
  },
  colors: ['#338AC6', '#338AC666', '#F4F4F4'],
  labels: ['Completed', 'Assigned', 'Remaining Total']
});
